// Version de la aplicacion: se incrementa a mano en cada entrega (se muestra en el footer)
export const VERSION = "4.0.0";
